import { render, staticRenderFns } from "./BrandPriceAdjustmentList.vue?vue&type=template&id=18d72017&scoped=true&"
import script from "./BrandPriceAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./BrandPriceAdjustmentList.vue?vue&type=script&lang=js&"
import style0 from "./BrandPriceAdjustmentList.vue?vue&type=style&index=0&id=18d72017&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d72017",
  null
  
)

export default component.exports